<script setup lang="ts">
import {CirclePlus} from "@lucide/vue";

const emit = defineEmits<{
    (e: 'create'): void;
}>();
</script>

<template>
  <button
    type="button"
    class="flex min-h-[172px] cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-[1.5px] border-dashed border-primary bg-white text-sm font-semibold text-primary transition-colors hover:bg-primary-lightest"
    @click="emit('create')"
  >
    <CirclePlus class="h-7 w-7" />Créer un cadeau
    <span class="max-w-[170px] text-center text-xs font-normal leading-snug text-muted-foreground">
      3 champs, moins d'une minute
    </span>
  </button>
</template>
